export type WhitelabelEnvironment = "qa" | "prod";

export const WHITELABEL_HOSTS: Record<WhitelabelEnvironment, string> = {
  qa: "https://whitelabelqa.bite-test.io",
  prod: "https://whitelabel.bite-test.io",
};

/** Page in the white label app that shows one database. */
export function databasePath(databaseId: string): string {
  return `/database/${encodeURIComponent(databaseId)}`;
}

/** Databases that live in the white label app itself, not in the BITE virtual-database group. */
export const WHITELABEL_DATABASES: ReadonlyArray<{ id: string; name: string }> = [
  { id: "0f5ae954-166c-4e32-abcd-81343ee05501", name: "White Label DB" },
];
